// No imports, so a browser bundle can deep-import this module (client-v2 does).

/**
 * Drops segments flagged `hideFromClient`, and each segment whose parent (by sequence) is hidden.
 * @template {{ sequence?: number | null, hideFromClient?: boolean | null, parentBySequence?: number | null }} T
 * @param {T[]} segments
 * @returns {T[]}
 */
export const omitHiddenSegments = segments => {
  const hiddenBySequence = new Map();
  for (const segment of segments) {
    if (segment.sequence != null) hiddenBySequence.set(segment.sequence, segment.hideFromClient === true);
  }
  return segments.filter(segment => {
    const parentHidden = segment.parentBySequence != null && hiddenBySequence.get(segment.parentBySequence) === true;
    return !(segment.hideFromClient === true || parentHidden);
  });
};
